'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgMeals(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M3.436 6.75L5.25 5.153 1.282 1.664c-.308-.27-.84-.197-1.032.153-.455.84-.289 1.874.5 2.574L3.436 6.75zm4.14-1.033c.97.42 2.332.125 3.34-.816 1.21-1.13 1.445-2.75.513-3.62-.925-.864-2.661-.651-3.878.479-1.008.94-1.324 2.212-.875 3.117l-5.74 5.36a.562.562 0 000 .834c.246.23.646.23.893 0l3.922-3.65 3.916 3.656c.248.23.647.23.894 0a.562.562 0 000-.834L6.645 6.587l.931-.87z", id: "Meals__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Meals__svg__a" })))));
}

module.exports = SvgMeals;
//# sourceMappingURL=Meals.js.map
